import { Component, ViewChild } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  DownloadDeviceDataIn,
  MeterGetAllDataIn,
  PageInfo,
  PendingMeterGetAllDataIn,
  PermissionsEnum,
  SortingType,
} from '../../../api/api-reference';
import { AuthService } from '../../../services/auth.service';
import { FileService } from '../../../services/file.service';
import { generateFileNameAppendix } from '../../../helper/download-filename';
import { UnconfiguredMetersComponent } from '../unconfigured-meters/unconfigured-meters.component';
import { DeviceManagementComponent } from '../device-management/device-management.component';

@Component({
  selector: 'app-device-tabs',
  standalone: true,
  imports: [TranslateModule, RouterOutlet, RouterLink],
  templateUrl: './device-tabs.component.html',
  styleUrl: './device-tabs.component.scss',
})
export class DeviceTabsComponent {
  PermissionsEnum = PermissionsEnum;
  public pageSize: number = 10;
  public pageNumber: number = 1;
  now = new Date();
  constructor(
    private router: Router,
    public authService: AuthService,
    private client: Client,
    private fileService: FileService,
    public toastr: ToastrService,
  ) { }

  requestData = new MeterGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
    startDate: undefined,
    endDate: undefined,
    sorting: SortingType.Descending,
    meterMakes: [],
    assetTypes: [],
    configurationProgressStatus: [],
    meterModels:[],
    serviceTypes: [],
    regions: [],
    areas: []
  });

  @ViewChild('childOutlet') childOutlet!: RouterOutlet;

  isActive(tab: string) {
    const currentRoute = this.router.url;
    if (currentRoute.includes(tab)) return true;
    else return false;
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }

  download() {
    const currentRoute = this.router.url;
    const fileNameApendix = generateFileNameAppendix();

    const component = this.childOutlet.component as DeviceManagementComponent;

    if (currentRoute.includes('all-devices')) {
      const data = new DownloadDeviceDataIn({
        ...component.requestData,
        meters: component.selectedRows,
        meterMakes: component.requestData.meterMakes ?? [],
        assetTypes: component.requestData.assetTypes ?? [],
        meterModels: component.requestData.meterModels ?? [],
        serviceTypes: component.requestData.serviceTypes ?? [],
        areas: component.requestData.areas ?? [],
        regions: component.requestData.regions ?? [],
        configurationProgressStatus: component.requestData.configurationProgressStatus ?? [],
      });

      this.client.downloadDeviceFile(data).subscribe({
        next: (response) => {
          this.fileService.downloadFile(
            response.data,
            response.fileName || `${(data.meters && data.meters.length > 0 ? 'SelectedMeters' : 'AllMeters')}${fileNameApendix}`,
          );
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (currentRoute.includes('uncofigured-meters')) {
      const data = new PendingMeterGetAllDataIn({
        ...(this.childOutlet.component as UnconfiguredMetersComponent).requestData,
      });
      this.client.downloadDeviceFile2(data).subscribe({
        next: (response) => {
          this.fileService.downloadFile(
            response.data,
            response.fileName || `UnconfiguredMeters${fileNameApendix}`,
          );
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    } else if (currentRoute.includes('recently-added')) {
      const recentlyAdded = this.childOutlet.component as DeviceManagementComponent;
      const data = new DownloadDeviceDataIn({
        ...recentlyAdded.requestData,
        meters: recentlyAdded.selectedRows,
        meterMakes: recentlyAdded.requestData.meterMakes ?? [],
        assetTypes: recentlyAdded.requestData.assetTypes ?? [],
        meterModels: recentlyAdded.requestData.meterModels ?? [],
        serviceTypes: recentlyAdded.requestData.serviceTypes ?? [],
        areas: recentlyAdded.requestData.areas ?? [],
        regions: recentlyAdded.requestData.regions ?? [],
        configurationProgressStatus: recentlyAdded.requestData.configurationProgressStatus ?? [],
      });
      this.client.downloadDeviceFile(data).subscribe({
        next: (response) => {
          this.fileService.downloadFile(
            response.data,
            response.fileName || `RecentlyAddedMeters${fileNameApendix}`,
          );
        },
        error: (err) => {
          this.toastr.error(err);
        },
      });
    }
  }
}
